// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2dmFg","containerItemsCenter":"Skeleton_containerItemsCenter__3qq-u"};